import { buildTranslate } from 'locales'

const t = buildTranslate('components.ai.segment_visualization')

interface SegmentRawDslProps {
  rawDsl: string | object | null
}

const SegmentRawDsl = ({ rawDsl }: SegmentRawDslProps) => {
  // Ensure rawDsl is always a string for rendering
  let dslString: string

  if (typeof rawDsl === 'string' && rawDsl.trim().length === 0) {
    dslString = t('raw_dsl_no_data')
  } else if (typeof rawDsl === 'string') {
    dslString = rawDsl
  } else if (rawDsl) {
    dslString = JSON.stringify(rawDsl, null, 2)
  } else {
    dslString = t('raw_dsl_no_data')
  }

  return (
    <details className="thanx-ai-segment-visualization__raw-dsl">
      <summary>{t('raw_dsl_summary')}</summary>
      <pre>{dslString}</pre>
    </details>
  )
}

export default SegmentRawDsl
